module.exports = __webpack_public_path__ + "static/DYNEEMA-7b652a6b15626ff9f6928fb463531344.svg";